import clsx from 'clsx';

const PRESETS = [
  { value: 'today', label: 'Oggi' },
  { value: '7d', label: '7g' },
  { value: '30d', label: '30g' },
  { value: 'qtr', label: 'Trim.' },
  { value: 'ytd', label: 'Anno' }
];

function ymd(d) {
  return d.toISOString().slice(0, 10);
}

/**
 * Period selector with presets plus a custom from/to range.
 * value: { period } for presets, or { from, to } (YYYY-MM-DD) for custom.
 */
export function RangeControl({ value, onChange }) {
  const isCustom = Boolean(value.from || value.to);

  const pill = (active) =>
    clsx('rounded px-2.5 py-1 text-xs font-medium transition-colors', active ? 'bg-ink text-white' : 'text-ink-muted hover:bg-surface-subtle hover:text-ink');

  const startCustom = () => {
    const to = new Date();
    const from = new Date(Date.now() - 30 * 86400000);
    onChange({ from: ymd(from), to: ymd(to) });
  };

  const dateInput = 'h-8 rounded-md border border-border-strong bg-surface-elevated px-2 text-xs text-ink focus:border-ink focus:outline-none';

  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="inline-flex items-center rounded-md border border-border-strong bg-surface-elevated p-0.5">
        {PRESETS.map((p) => (
          <button key={p.value} type="button" className={pill(!isCustom && value.period === p.value)} onClick={() => onChange({ period: p.value })}>
            {p.label}
          </button>
        ))}
        <button type="button" className={pill(isCustom)} onClick={startCustom}>Personalizzato</button>
      </div>

      {isCustom && (
        <div className="flex items-center gap-1.5">
          <input type="date" className={dateInput} value={value.from || ''} max={value.to || undefined} onChange={(e) => onChange({ from: e.target.value, to: value.to })} />
          <span className="text-xs text-ink-muted">→</span>
          <input type="date" className={dateInput} value={value.to || ''} min={value.from || undefined} onChange={(e) => onChange({ from: value.from, to: e.target.value })} />
        </div>
      )}
    </div>
  );
}
